<template>
  <div class="div-btn">
    <div class="btn_box">
      <button @tap="clickHandler" class="anBtn" :class="{ fill }" :disabled="disabled" :style="
          'background: ' +
          bg +
          ';color:' +
          color +
          ';border-radius:' +
          radius +
          ';border:' +
          border +
          ';height:' +
          height +
          ';line-height:' +
          height +
          ';padding:'+
          padding +';'
        ">
        <slot></slot>
      </button>
    </div>
  </div>
</template>
    <script>
export default {
  name: "div-btn",
  props: {
    fill: {
      type: Boolean,
      default: true,
    },
    padding: {
      type: String,
      default: "0",
    },
    color: {
      type: String,
      default: "#fff",
    },
    bg: {
      type: String,
      default: "#e14e3a",
    },
    radius: {
      type: String,
      default: "12vw",
    },
    height: {
      type: String,
      default: "12vw",
    },
    border: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      disabled: false,
    }
  },
  methods: {
    clickHandler(e) {
      if (this.disabled) {
        return false
      }
      this.disabled = true
      this.$emit("click")
    },
  },
}
</script>
    <style lang ="less" scoped >
.div-btn {
  .fill {
    width: 100%;
    margin: 0 auto;
  }
  .btn_box {
    box-sizing: border-box;
    text-align: center;
  }

  .anBtn {
    padding: 0;
    color: #fff;
    font-size: 4vw;
    transform: scale(1);
    transition: all 0.25s;
  }

  .anBtn:active {
    transform: scale(0.9);
    opacity: 0.9;
  }

  .anBtn::after {
    border: 0;
  }

  .anBtn[disabled] {
    transform: scale(1);
    opacity: 1;
  }

  .anBtn[disabled]:active {
    transform: scale(0.9);
    opacity: 0.5;
  }

  .anBtn[disabled]:not([type]) {
    /* transform: scale(0.9); */
    opacity: 0.5;
  }
}
</style>
